import { FC } from 'react';
import { v4 as uuid } from 'uuid';
import { IOrderDetailsTabList } from '../../../../../types/orders';

interface IOrderDetailsTabs {
  tabsList: IOrderDetailsTabList[];
  selectedTabId: number;
  handleChangeSelectedTabId: (newTabId: number) => void;
}
const OrderDetailsTabs: FC<IOrderDetailsTabs> = ({
  tabsList,
  handleChangeSelectedTabId,
  selectedTabId
}: IOrderDetailsTabs) => {
  const generateTabs = (tabsList: IOrderDetailsTabList[]) => {
    return tabsList.map((tab, index) => {
      return (
        <div
          key={uuid()}
          onClick={() => {
            if (typeof tab.tabId === 'number') {
              handleChangeSelectedTabId(tab.tabId);
            }
          }}
          className={`orderDetailsTab ${selectedTabId === tab.tabId ? 'selected' : ''}`}
        >
          <div className="tabName">{tab.tabName}</div>
        </div>
      );
    });
  };
  return <div className="OrderDetailsTabs">{tabsList && tabsList.length > 0 && generateTabs(tabsList)}</div>;
};
export default OrderDetailsTabs;
